import React, { DetailedHTMLProps, HTMLAttributes, ReactElement, useMemo } from 'react';

import { ComposableListItem, IComposableListItem } from '../../molecules';
import { makeClassNames } from '../../../utils/styles';
import { FieldDefinition } from '../../molecules/composable-list-item/field';

import './composable-list.scss';

interface IComposableListClasses {
  wrapper: string;
  header: string;
}

export type Header<I extends object> = {
  [Property in keyof I]: string;
};

export interface IComposableListAccessibleItem extends IComposableListItem {
  title?: string;
}

export interface IComposableListProps<I extends IComposableListAccessibleItem>
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  items: Array<I>;
  headers: Partial<Header<I>>;
  inverted?: boolean;
  fields?: Array<FieldDefinition<Omit<I, 'targetUrl'>>>;
  keyPrefix?: string;
}

const classNames = (): IComposableListClasses =>
  makeClassNames({
    wrapper: 'composable-list',
    header: 'composable-list__header',
  }) as IComposableListClasses;

function ComposableList<T extends IComposableListAccessibleItem>({
  items,
  headers,
  inverted = false,
  fields,
  keyPrefix,
  ...htmlProps
}: IComposableListProps<T>): ReactElement {
  const cn = useMemo<IComposableListClasses>(() => classNames(), []);

  return (
    <div {...htmlProps} className={cn.wrapper}>
      {/* @ts-ignore */}
      <ComposableListItem<Partial<Header<T>>>
        // @ts-ignore
        data={headers}
        fields={Object.keys(headers) as FieldDefinition<Omit<Header<T>, 'targetUrl'>>[]}
        inverted={inverted}
        className={cn.header}
        aria-hidden="true"
      />
      {items.map((item, index) => (
        <ComposableListItem<T>
          key={`${keyPrefix ?? Object.keys(headers).join('-')}-${index}`}
          data={item}
          // @ts-ignore
          fields={fields ?? (Object.keys(headers) as FieldDefinition<Omit<T, 'targetUrl'>>[])}
          inverted={inverted}
          title={item.title}
        />
      ))}
    </div>
  );
}
export default ComposableList;
